export default __webpack_public_path__ + "static/media/checkedRadioBlack.7100999b.svg";